import type { TFunction } from 'i18next';

/**
 * Translates tipo values to localized display strings.
 * Use this instead of displaying raw 'Internacional' or 'Nacional' strings.
 *
 * @param tipo - The trip type ('Internacional' or 'Nacional')
 * @param t - The i18next translation function
 * @returns Translated tipo label
 */
export function getTipoLabel(tipo: 'Internacional' | 'Nacional', t: TFunction): string {
  return tipo === 'Internacional' ? t('tipo.internacional') : t('tipo.nacional');
}

/**
 * Translates tipo values to abbreviated localized strings for mobile/compact views.
 *
 * @param tipo - The trip type ('Internacional' or 'Nacional')
 * @param t - The i18next translation function
 * @returns Abbreviated translated tipo label
 */
export function getTipoLabelShort(tipo: 'Internacional' | 'Nacional', t: TFunction): string {
  return tipo === 'Internacional' ? t('tipo.internacionalShort') : t('tipo.nacionalShort');
}
